module.exports = class Item
  piece: {}
  attr: ''
  text: ''
  h: (@attr) ->
    @
  label: (@text) ->
    @
  build: ->
    @piece

  hide: @piece.hide()
  show: @piece.show()
  remove: @piece.remove()


